import React, { useEffect } from 'react';

const GoogleContactsCallback = () => {
  useEffect(() => {
    const hash = window.location.hash.startsWith('#') ? window.location.hash.slice(1) : window.location.hash;
    const params = new URLSearchParams(hash);
    const accessToken = params.get('access_token');
    const error = params.get('error');
    const payload = {
      type: 'google-contacts-token',
      accessToken,
      error,
    };

    if (window.opener) {
      window.opener.postMessage(payload, window.location.origin);
    }

    window.localStorage.setItem('googleContactsAuthResult', JSON.stringify(payload));

    window.setTimeout(() => {
      if (window.history.length > 1) {
        window.close();
      } else {
        window.location.replace('/customers');
      }
    }, 150);
  }, []);

  return null;
};

export default GoogleContactsCallback;
